import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {HTTPSort} from 'src/app/models';
import {ToursStateService} from 'src/app/services/tours-state.service';
import {environment} from "../../../../environments/environment";
import {WindowRefService} from "../../../services/window-ref.service";
import {SearchService} from "../../../services/search/search.service";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-tours-sort',
  templateUrl: environment.mobile ? './tours-sort.component.mobile.html' : './tours-sort.component.html',
  styleUrls: environment.mobile ? ['./tours-sort.component.mobile.scss'] : ['./tours-sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class ToursSortComponent implements OnInit, OnDestroy {
  public readonly SORT_BY_PRICE = HTTPSort.BY_PRICE;
  public readonly SORT_BY_SALES = HTTPSort.BY_SALES;
  public readonly SORT_BY_RATING = HTTPSort.BY_RATING;
  public readonly SORT_BY_WRATING = HTTPSort.BY_WRATING;
  public readonly SORT_BY_PRICE_QUALITY = HTTPSort.BY_PRICE_QUALITY;

  currentSort = this.hotelToursPageConfig.searchDefaultSortVariant || this.hotelToursPageConfig.searchDefaultSortTestVariant;
  messages: any = {};
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private state: ToursStateService, private searchService: SearchService,
    private window: WindowRefService,
    private cdRef: ChangeDetectorRef,
  ) {
    this.messages = this.hotelToursPageConfig.translates.toursSort;
  }

  ngOnInit(): void {
    this.currentSort = this.state.getState().sort;

    this.state.updated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.currentSort = state.sort;
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectSort(sort: HTTPSort) {
    if (this.currentSort === sort) {
    } else {
      this.currentSort = sort;
      this.state.setSort(sort);
      this.searchService.sortChanged();
    }

    let sortName;

    switch (sort) {
      case this.SORT_BY_PRICE:
        sortName = 'sorted_from_cheap_to_expensive';
        break;
      case this.SORT_BY_SALES:
        sortName = 'sorted_popular_first';
        break;
      case this.SORT_BY_RATING:
        sortName = 'sorted_according_tourist_assessment';
        break;
      case this.SORT_BY_WRATING:
        sortName = 'sorted_by_rating_and_number_of_reviews';
        break;
      case this.SORT_BY_PRICE_QUALITY:
        sortName = 'sorted_by_price_and_quality';
        break;
      default:
        sortName = null;
    }

    if (sortName) {
      this.window.nativeWindow.brxTracking.sendAnalyticsEvent(sortName);
    }
  }
}
